import Globalize from '@sprinx/globalize';
import forDate from '../utils/forDate';
import forLocale from '../utils/forLocale';
var localeFmt = {};
/**
 * @param {Date | string} [d]
 * @returns {string}
 */

var dateTimeFormatter = function dateTimeFormatter(d) {
  return forLocale(localeFmt, function (fmt) {
    return forDate(d, function (td) {
      /* istanbul ignore next */
      if (!fmt) {
        fmt = Globalize.dateFormatter({
          skeleton: 'yMdhm'
        });
      }

      return fmt(td);
    });
  });
};

export default dateTimeFormatter;